import { OktaAuth, type OktaAuthOptions } from '@okta/okta-auth-js';

const oktaConfig: OktaAuthOptions = {
  clientId: import.meta.env.VITE_PATIENT_ADMIN_OKTA_CLIENT_ID,
  cookies: {
    secure: import.meta.env.PROD,
  },
  issuer: import.meta.env.VITE_PATIENT_ADMIN_OKTA_ISSUER,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ['openid', 'profile', 'email'],
  tokenManager: {
    autoRenew: true,
    storage: 'sessionStorage',
  },
  pkce: true,
};

export const oktaAuth = new OktaAuth(oktaConfig);
